module.exports = __webpack_public_path__ + "img/slide2-7.69ff8115.png";